export const maskPhoneNumber = (phoneStr, isdCode) => {
  if (!phoneStr) return "-";

  const str = String(phoneStr);
  let masked;
  if (str.length >= 10) {
    masked = str.slice(0, 2) + "XXXXX" + str.slice(7);
  } else if (str.length > 2) {
    masked = "x".repeat(str.length - 2) + str.slice(-2);
  } else {
    masked = str;
  }

  const isd = String(isdCode ?? "").trim();
  return isd ? `${isd} ${masked}` : masked;
};

export const getCallIdFromResponse = (res) =>
  res?.call_id || res?.callId || res?.data?.call_id || res?.data?.callId || "";

export const getOtpCodeFromResponse = (res) =>
  res?.otpCode || res?.data?.otpCode || res?.otp_code || res?.data?.otp_code;
